import(/* webpackMode: "eager", webpackExports: ["PostActions","PostView"] */ "/home/runner/work/cici/cici/app/blog/[id]/component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/cici/cici/components/LikeButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PhotoGallery"] */ "/home/runner/work/cici/cici/components/PhotoGallery.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/cici/cici/node_modules/discussing/dist/components/Discussion.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/cici/cici/node_modules/katex/dist/katex.min.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/cici/cici/node_modules/next/dist/client/image-component.js");
